export const environment = {
    production: true,
    logErrorInConsole: false,
    environmentName: "production",
    version: require("../../package.json").version,
    httpRequestTimeoutSeconds: 120,
    utcDateFormat: "yyyy-MM-dd HH:mm:ss",
    frontedAppUrl: "https://beigene-patientcases.web.app/",
    oauthBaseAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/auth/",
    usersAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/users/",
    rolesAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/roles/",
    organizationsAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/organizations/",
    profileAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/profile/",
    resetPasswordAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/resetpassword/",
    languagesAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/languages/",
    smtpMailAccountsAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/mailaccounts/",
    mailtemplatesAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/mailtemplates/",
    systemLogMessagesAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/systemlogs/",
    systemJobPerformancesAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/systemjobs/",
    systemErrorsAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/systemerrors/",
    patientCasesAPI: "https://beigene-patientcases-api-lciurtawya-ey.a.run.app/api/v1/patientcases/"
};
